module.exports = __webpack_public_path__ + "static/media/calendar.db400827.svg";